import getConfig from './get-config.gql'
import getUser from './get-user.gql'
import getProviders from './get-providers.gql'
import getImports from './get-imports.gql'
import getImportDetails from './get-import-details.gql'
import getImportSourcefiles from './get-import-sourcefiles.gql'
import getImportTransformedFile from './get-import-transformed-file.gql'
import getImportUpload from './get-import-upload.gql'
import getPlans from './get-plans.gql'
import getPlansCount from './get-plans-count.gql'
import getFiduciaries from './get-fiduciaries.gql'
import getPrograms from './get-programs.gql'
import getPlanStatuses from './get-plan-statuses.gql'
import getProducts from './get-products.gql'
import getMenus from './get-menus.gql'
import getQuarterEndWindow from './get-quarter-end-window.gql'

export const GET_CONFIG = getConfig
export const GET_USER = getUser
export const GET_PROVIDERS = getProviders
export const GET_IMPORTS = getImports
export const GET_IMPORT_DETAILS = getImportDetails
export const GET_IMPORT_SOURCEFILES = getImportSourcefiles
export const GET_IMPORT_TRANSFORMED_FILE = getImportTransformedFile
export const GET_IMPORT_UPLOAD = getImportUpload
export const GET_PLANS = getPlans
export const GET_PLANS_COUNT = getPlansCount
export const GET_FIDUCIARIES = getFiduciaries
export const GET_PROGRAMS = getPrograms
export const GET_PLAN_STATUSES = getPlanStatuses
export const GET_PRODUCTS = getProducts
export const GET_MENUS = getMenus
export const GET_QUARTER_END_WINDOW = getQuarterEndWindow
